import axios from 'axios';
import { API_BASE_URL } from '../config';

// 获取认证头
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
};

// 获取教师的所有学生
export const getTeacherStudents = async () => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/teacher/students`,
      getAuthHeaders()
    );
    return response.data.data || [];
  } catch (error) {
    console.error('获取教师的学生列表失败:', error);
    throw error;
  }
};

// 添加学生到教师
export const addStudentToTeacher = async (studentId) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/teacher/students`,
      { studentId: studentId },
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    console.error('添加学生到教师失败:', error);
    throw error;
  }
};

// 移除教师的学生
export const removeStudentFromTeacher = async (studentId) => {
  try {
    const response = await axios.delete(
      `${API_BASE_URL}/teacher/students/${studentId}`,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    console.error('从教师移除学生失败:', error);
    throw error;
  }
};

// 获取可以被添加的学生列表（不属于该教师的学生）
export const getAvailableStudents = async () => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/teacher/available-students`,
      getAuthHeaders()
    );
    return response.data.data || [];
  } catch (error) {
    console.error('获取可用学生列表失败:', error);
    throw error;
  }
}; 